import React from "react";
import { Paragraph16Regular } from "../../../common/Typography/Paragraph16";
import BrowseFilesButton from "./BrowseFilesButton";
import { FileUploadProps } from "./FileUpload";
import {
  FileUploadContainer,
  FormatBadge,
  Right,
  SecondaryText,
} from "./styled";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useFileDragAndDrop } from "../../../common/hooks/useFileDragAndDrop";

const StyledFileUpload = styled(FileUploadContainer)`
  position: relative;

  .right {
    p {
      border-right: 1px solid ${(props) => props.theme.borderColor};
      padding-right: 24px;
      margin-right: 24px;
      max-width: 96px;
      text-align: right;
      box-sizing: content-box;
      vertical-align: middle;
      height: fit-content;
      margin-top: auto;
      margin-bottom: auto;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: center;
    justify-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    .left {
      .badge {
        position: absolute;
        top: 0;
        left: 10px;
      }
    }
    .right {
      flex-direction: column;
      text-align: center;
      align-items: center;

      p {
        margin: 0;
        padding: 0;
        border: none;
        text-align: center;
        margin-bottom: 8px;
      }
    }
  }
`;

const AudioUpload = ({
  description,
  fileFormats,
  name,
  label,
  error,
  isProcessing,
  ...inputProps
}: FileUploadProps) => {
  const { t } = useTranslation();
  const {
    eventHandlers,
    isDraggedOver,
    isFileUnknown,
    isFileInvalid,
    isFileValid,
  } = useFileDragAndDrop(fileFormats);

  return (
    <StyledFileUpload
      $isDragging={isDraggedOver}
      $unknown={isFileUnknown}
      $valid={isFileValid}
      $invalid={isFileInvalid}
      $error={error}
      {...eventHandlers}
    >
      <div className="left">
        <Paragraph16Regular>{description}</Paragraph16Regular>
        {label && <FormatBadge className="badge">{label}</FormatBadge>}
      </div>
      <Right className="right">
        <SecondaryText>{t("file-upload-drag-and-drop-here")}</SecondaryText>
        <BrowseFilesButton
          name={name}
          accept={fileFormats.join(",")}
          onChange={inputProps.onChange}
          isProcessing={isProcessing}
        />
      </Right>
    </StyledFileUpload>
  );
};

export default AudioUpload;
